export default __webpack_public_path__ + "static/media/sitting.861c51a4.png";